import { render, staticRenderFns, recyclableRender, components } from "./stockCheck.vue?vue&type=template&id=3c366cb3&"
var renderjs
import script from "./stockCheck.vue?vue&type=script&lang=js&"
export * from "./stockCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/basics/stockCheck.vue"
export default component.exports